import { InfoCircleFilled } from '@ant-design/icons';
import { Card, theme } from 'antd';
import { useTranslation } from 'react-i18next';

export const StartDateNotStarted = () => {
	const { t } = useTranslation();
	const {
		token: { red5 },
	} = theme.useToken();

	return (
		<Card>
			<div className="flex items-center justify-center py-4 text-xl">
				<InfoCircleFilled style={{ fontSize: '16px', color: red5 }} />
				<h4 className="ml-2"> {t('waitTillInterviewDateToBePassed')}</h4>
			</div>
		</Card>
	);
};
